/**
 * bleeme-withdrawal
 *
 * Begleitet die Widerrufsfunktion (snippets/bleeme-withdrawal-form.liquid).
 *
 * Das Formular wird BEWUSST nativ abgeschickt, nicht per fetch: Shopifys
 * Kontaktformular haengt an der unsichtbaren reCAPTCHA-Pruefung. Ein
 * abgefangener POST kann ohne deren Token als Spam verworfen werden - bei
 * einer Widerrufserklaerung waere das ein verlorener Rechtsakt.
 *
 * Dieses Skript macht deshalb nur zwei Dinge:
 *   1. Es merkt sich die Feldwerte vor dem Absenden.
 *   2. Nach Shopifys Redirect (?contact_posted=true) meldet es das Ereignis an
 *      Klaviyo, das daraus die Eingangsbestaetigung mit Zeitstempel schickt,
 *      und zeigt die Bestaetigung an, falls der Nutzer nicht auf der
 *      Widerrufsseite gelandet ist.
 *
 * Massgeblich fuer die Uhrzeit in der Bestaetigung ist der serverseitige
 * Zeitstempel des Klaviyo-Events, nie die Uhr des Browsers.
 *
 * Faellt sessionStorage oder Klaviyo aus, bleibt die Erklaerung trotzdem im
 * Shop-Postfach: das Kontaktformular laeuft serverseitig und braucht dieses
 * Skript nicht.
 */
(() => {
  const STASH_KEY = 'bleeme:withdrawal';
  const METRIC = 'Widerruf eingegangen';

  // Gesetzlich vorgegebene Sprache, siehe Snippet - bewusst nicht uebersetzt.
  const SUCCESS_TITLE = 'Vertrag widerrufen';
  const SUCCESS_BODY =
    'Dein Widerruf ist bei uns eingegangen. Du erhältst in Kürze eine Bestätigung per E-Mail.';

  const readStash = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STASH_KEY) || 'null');
    } catch (error) {
      return null;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.bleeme-withdrawal__form');
    if (!form) return;

    const data = new FormData(form);
    try {
      sessionStorage.setItem(
        STASH_KEY,
        JSON.stringify({
          name: data.get('contact[Name]') || '',
          email: data.get('contact[email]') || '',
          order: data.get('contact[Bestellnummer]') || ''
        })
      );
    } catch (error) {
      // Privater Modus kann sessionStorage sperren. Dann entfaellt nur die
      // automatische Bestaetigung, nicht der Widerruf selbst.
    }
  });

  if (!new URLSearchParams(window.location.search).has('contact_posted')) return;

  const stash = readStash();
  if (!stash || !stash.email) return;

  try {
    sessionStorage.removeItem(STASH_KEY);
  } catch (error) {
    // egal, das Event ist gleich raus
  }

  window.klaviyo = window.klaviyo || [];
  window.klaviyo.push(['identify', { $email: stash.email, $first_name: stash.name }]);
  window.klaviyo.push([
    'track',
    METRIC,
    { Name: stash.name, Email: stash.email, Bestellnummer: stash.order }
  ]);

  // Bestellnummer nachtragen. Shopify gibt eigene Felder wie contact[Bestellnummer]
  // nach dem POST nicht an Liquid zurueck - der Wert existiert nur hier. Fehlt er,
  // bleibt die Zeile ausgeblendet und der Rest der Bestaetigung steht trotzdem.
  const orderLine = document.querySelector('[data-withdrawal-order]');
  if (orderLine && stash.order) {
    orderLine.textContent = `Bestellnummer: ${stash.order}`;
    orderLine.hidden = false;
  }

  // Steht das Formular auf dieser Seite, hat Liquid die Bestaetigung schon
  // gerendert (form.posted_successfully?). Sonst zeigen wir sie im Drawer.
  if (document.querySelector('[data-withdrawal-form]')) return;

  const drawer = document.getElementById('PageDrawer');
  if (!drawer || typeof drawer.show !== 'function') return;

  const title = drawer.querySelector('[data-drawer-title]');
  const content = drawer.querySelector('[data-drawer-content]');
  if (!title || !content) return;

  title.textContent = SUCCESS_TITLE;
  content.innerHTML = `<div class="rte text-base md:text-lg"><p>${SUCCESS_BODY}</p></div>`;
  drawer.show();
})();
